import React from "react";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import "./LifeAtTooltip.scss";

interface LifeAtTooltipProps {
    showTooltip: boolean;
    title?: string;
    message?: string | JSX.Element;
    mouseCoords?: { top: number; left: number };
}
export default function LifeAtTooltip(props: LifeAtTooltipProps) {
    const { lightMode }: AppearanceContextType = useAppearanceContext();

    const coords = props.mouseCoords ? props.mouseCoords : {};

    return props.showTooltip ? (
        <div
            className={`lifeat-tooltip ${lightMode ? "light" : "dark"}`}
            style={{ display: props.showTooltip ? "block" : "none", ...coords, pointerEvents: "none" }}
        >
            <h3 className={`tooltip-title`}>{props.title}</h3>
            <div className={`tooltip-message`}>{props.message}</div>
        </div>
    ) : null;
}
